import Language from '@mui/icons-material/Language';
import { Stack, Typography } from '@mui/material';
import { OnlineTrainingCourseDetail } from '@onlineTraining/types';

export const LanguageSelector = ({
    displayData,
    selectedLanguage,
    onSelect,
}: {
    displayData: OnlineTrainingCourseDetail | undefined;
    selectedLanguage: string;
    onSelect: (code: string) => void;
}) => {
    const languages = displayData?.available_languages?.length
        ? displayData.available_languages
        : displayData?.language
        ? [displayData.language]
        : [];

    return (
        <Stack direction="row" alignItems="start" gap="5px" paddingTop={2}>
            <Language fontSize="small" />
            {languages.map((language) => (
                <Typography
                    key={language.code}
                    onClick={() => onSelect(language.code)}
                    className="cursor-pointer hover:text-primary-500"
                    component="span"
                    fontSize={14}
                    fontWeight={500}
                    lineHeight="20px"
                    color={selectedLanguage === language.code ? 'primary-500.main' : 'neutral-900.main'}
                >
                    {language.code.toLocaleUpperCase()}
                </Typography>
            ))}
        </Stack>
    );
};
